/**
 * @generated SignedSource<<00473013b80bc3ffb9d4b7acafe85213>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type APPROVAL_STATUS = "APPROVED" | "SUBMITTED" | "NOT_SUBMITTED" | "%future added value";
export type APPROVAL_TYPE = "SUBMIT_TIME_OFF" | "SUBMIT" | "APPROVE" | "FORCE_APPROVE" | "UNSUBMIT" | "UNAPPROVE" | "%future added value";
export type UpdateApprovalStatusInput = {
  personIds?: ReadonlyArray<string | null> | null;
  projectIds?: ReadonlyArray<string | null> | null;
  idleTimeIds?: ReadonlyArray<string | null> | null;
  approvalType?: APPROVAL_TYPE | null;
  startYear?: number | null;
  startMonth?: number | null;
  startDay?: number | null;
  endYear?: number | null;
  endMonth?: number | null;
  endDay?: number | null;
  sendNotification?: boolean | null;
  rejectionMessage?: string | null;
  includeTimeOff?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UpdateApprovalStatusMutation$variables = {
  input: UpdateApprovalStatusInput;
};
export type UpdateApprovalStatusMutation$data = {
  readonly updateApprovalStatus: {
    readonly timeRegs: ReadonlyArray<{
      readonly id: string;
      readonly approvalStatus: APPROVAL_STATUS | null;
      readonly noApprovalStatusChange: string | null;
      readonly lockedInPeriod: boolean | null;
    } | null> | null;
    readonly persons: ReadonlyArray<{
      readonly id: string;
      readonly submitLockedDateYear: number | null;
      readonly submitLockedDateMonth: number | null;
      readonly submitLockedDateDay: number | null;
    } | null> | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type UpdateApprovalStatusMutation = {
  variables: UpdateApprovalStatusMutation$variables;
  response: UpdateApprovalStatusMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateApprovalStatusPayload",
    "kind": "LinkedField",
    "name": "updateApprovalStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TimeRegType",
        "kind": "LinkedField",
        "name": "timeRegs",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "approvalStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "noApprovalStatusChange",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lockedInPeriod",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Person",
        "kind": "LinkedField",
        "name": "persons",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitLockedDateDay",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateApprovalStatusMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateApprovalStatusMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "00e1cb02cfdde886f85117a605bd52f6",
    "id": null,
    "metadata": {},
    "name": "UpdateApprovalStatusMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateApprovalStatusMutation(\n  $input: UpdateApprovalStatusInput!\n) {\n  updateApprovalStatus(input: $input) {\n    timeRegs {\n      id\n      approvalStatus\n      noApprovalStatusChange\n      lockedInPeriod\n    }\n    persons {\n      id\n      submitLockedDateYear\n      submitLockedDateMonth\n      submitLockedDateDay\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "3827fa0e520efa40dd33536702a09326";

export default node;
